/**
 * @Author:      jiang.weiwei
 * @DateTime:    2017-12-13 19:28:40
 * @Description: ugc稿件管理
 */
"use strict";
angular.module("ugcManageRouterModule", []).
config(["$stateProvider", function($stateProvider) {
    $stateProvider.state("backstage.ugcmanage", {
        url: "/ugcmanage",
        views: {
            "":{
                template:'<div class="ugcmanage" ui-veiw="main"></div>',
            }
        }
    }).state("backstage.ugcmanage.usercontribution", {
        url: "/usercontribution",
        views: {
            "main@backstage":{
                templateUrl:'./main/backstage/ugcManage/userContribution/userContribution_tpl.html',
                controller:'userContributionCtrl'
            }
        }
    }).state("backstage.ugcmanage.userburst", {
        url: "/userburst",
        views: {
            "main@backstage":{
                templateUrl:'./main/backstage/ugcManage/userBurst/userBurst_tpl.html',
                controller:'userBurstCtrl'
            }
        }
    }).state("backstage.ugcmanage.submissionclassifiy", {
        url: "/submissionclassifiy",
        views: {
            "main@backstage":{
                templateUrl:'./main/backstage/ugcManage/submissionClassifiy/submissionClassifiy_tpl.html',
                controller:'submissionClassifiyCtrl'
            }
        }
    }).state("backstage.ugcmanage.submissionclassifiy.twolevelclassifiy", {
        url: "/twolevelclassifiy?classId&className",
        views: {
            "main@backstage":{
                templateUrl:'./main/backstage/ugcManage/submissionClassifiy/twoLevelClassifiy/twoLevelClassifiy_tpl.html',
                controller:'twoLevelClassifiyCtrl'
            }
        }
    });
}]);